import FormFieldType from "../Classes/FormFieldType";
import FormMarkdown from "../Classes/FormMarkdown";
import FormOptionGroup from "../Classes/FormOptionGroup";
import FormOptionItem from "../Classes/FormOptionItem";
import FormQuestionFromTool from "../Classes/FormQuestionFromTool";
import FormRuleAction from "../Classes/FormRuleAction";
import FormRuleChain from "../Classes/FormRuleChain";
import FormRuleFromTool from "../Classes/FormRuleFromTool";
import FormSection from "../Classes/FormSection";
import {
    CommonListNames,
    FieldTypes,
    KeyList,
    KeyListPretty,
    ListEditorTypes,
    OperatorNames
} from "../Constants/DataModelToolConstants";

export const DataModelToolHelpers = () => {
    let sqlError = ""

    const SaveJsonAsSqlFile = (jsonContents) => {
        let jsonObject = JSON.parse(jsonContents);

        let returnValue = RenderSqlScriptFromDataModelFile(jsonObject)

        return returnValue;
    }

    async function SaveFileContents(fileName, fileToSave, fileType) {
        if (sqlError == "") {
            const { electron } = window;

            const dialogConfig = {
                title: 'Save a file',
                buttonLabel: 'Save file',
                properties: ['saveFile'],
                defaultPath: fileName,
                filters:
                    [
                        fileType
                    ]
            };

            let saveFileDialog = await electron.openDialog('showSaveDialog', dialogConfig);

            electron.writeFile(saveFileDialog.filePath, fileToSave);
        }
        else {
            alert(sqlError);
        }
    }

    function RenderSqlScriptFromDataModelFile(dataModel) {
        let optionGroups = GetOptionGroups(dataModel);
        let markdowns = BuildMarkdowns(dataModel);

        let formSections = BuildSectionsAndQuestions(optionGroups, markdowns, dataModel);
        let formRules = BuildRules(dataModel);
        let renderedOptions = RenderOptionGroupsAndOptionItems(optionGroups);
        let renderedVariables = RenderVariables(dataModel);
        let renderedMarkdowns = RenderMarkdowns(markdowns);
        let renderedSections = RenderSections(dataModel.assistanceFormId, formSections);


        let renderedQuestions = RenderQuestions(dataModel.assistanceFormId, formSections, markdowns, optionGroups);
        let renderedFormQuestionToAssistanceServiceRecords = RenderFormQuestionToAssistanceService(dataModel, formSections);
        let renderedFormQuestionToBrandAndServiceRecords = RenderFormQuestionToBrandAndService(dataModel);
        let renderedFormQuestionToFoundationDiseaseTypeRecords = ""; // update schema to include dbo.FormQuestionToFoundationDiseaseType? - Amanda D.


        let renderedFormRules = RenderFormRules(dataModel.formRuleSetId, formRules);
        let renderedFormRuleActions = RenderFormRuleActions(formRules);
        let renderedFormRuleChains = RenderFormRuleChains(formRules);

        let renderedFormRuleSet = RenderRuleSet(dataModel.baseName);
        let renderedTempToPersistent = RenderTempToPersistent();
        let renderedRuleSetToAssistanceProgram = RenderRuleSetToAssistanceProgram();
        let renderedSetup = RenderSetup(dataModel.interfaceId);
        let renderedCleanup = RenderCleanUp();

        let returnValue = "";

        returnValue = returnValue.concat(renderedVariables, renderedOptions, renderedMarkdowns, renderedSections, renderedQuestions,
            renderedFormQuestionToAssistanceServiceRecords, renderedFormQuestionToBrandAndServiceRecords,
            renderedFormQuestionToFoundationDiseaseTypeRecords, renderedFormRules, renderedFormRuleActions, renderedFormRuleChains,
            renderedSetup, renderedFormRuleSet, renderedTempToPersistent, renderedRuleSetToAssistanceProgram, renderedCleanup);

        return returnValue;
    }

    function GetOptionGroups(dataModel) {
        let currentTotalIndex = 0;
        let currentItemIndex = 0;

        let allOptions =
            dataModel.questions.filter(qu => qu.options?.length > 0 &&
                ListEditorTypes.includes(qu.selectedType) && !IsItYesNoField(qu) && !IsItACommonList(qu)).map((q, overallIndex) =>
                    new FormOptionGroup(
                        parseInt(dataModel.addressStart) + (overallIndex),
                        q.listName,
                        q.options?.map((o, index) => new FormOptionItem(
                            parseInt(dataModel.addressStart) + (overallIndex), dataModel.addressStart + (currentTotalIndex++), o, q.values[index], q.values[index] == q.defaultValue ? 1 : 0, index + 1))
                    ));


        const unique = [...new Map(allOptions.map((m) => [m.Name, m])).values()];

        currentTotalIndex = 0
        for (const current of unique) {
            current.Id = parseInt(dataModel.addressStart) + (currentTotalIndex)
            for (const currItem of current.Items) {
                currItem.Id = parseInt(dataModel.addressStart) + (currentItemIndex)
                currItem.OptionGroupId = current.Id
                currentItemIndex++
            }
            currentTotalIndex++
        }

        return unique;
    }

    function IsItACommonList(question) {
        if (CommonListNames.some(cl => cl.Name == question.listName)) {
            return true;
        }
        return false;
    }

    function IsItYesNoField(question) {
        if (question.selectedType == 'yes|no' || question.type == 'yes|no' || question.SelectedType == 'yes|no' || question.Type == 'yes|no') {
            return true;
        }
        if (question.values?.length == 2) {
            if (question.options[0] == 'Yes' && question.options[1] == 'No') {
                return true;
            }
        }
        return false;
    }


    function RenderVariables(dataModelFile) {
        let template = `
    ---------------
        -- Variables --
    ---------------
        DECLARE @AssistanceFormId INT = ***ASSISTANCEFORMID***
, @FormName NVARCHAR(1024) = N'***FORMNAME***'
    , @FormDescription NVARCHAR(1024) = N'***FORMDESCRIPTION***'
    , @FormRuleSetId INT = ***FORMRULESETID***
, @AddressStart INT = ***ADDRESSSTART***
, @AddressEnd INT = ***ADDRESSEND***
    ;
    DECLARE @AssistanceServices TABLE (AssistanceServiceId int)
    INSERT INTO @AssistanceServices(AssistanceServiceId)
VALUES
***ASSISTANCESERVICEIDS***
    ;
    `;

        let concatString = "";

        return template
            .replace("***ASSISTANCEFORMID***", dataModelFile.assistanceFormId)
            .replace("***FORMNAME***", EscapeSingleQuotes(dataModelFile.formName))
            .replace("***FORMDESCRIPTION***", EscapeSingleQuotes(dataModelFile.formDescription))
            .replace("***FORMRULESETID***", dataModelFile.formRuleSetId)
            .replace("***ADDRESSSTART***", dataModelFile.addressStart)
            .replace("***ADDRESSEND***", dataModelFile.addressEnd)
            .replace("***ASSISTANCESERVICEIDS***", concatString.concat("", dataModelFile.serviceList.map(i => "\r\n(" + i.serviceId + ")")));
    }


    function RenderOptionGroupsAndOptionItems(options) {
        let template = `
    --FormOptionGroup
    IF OBJECT_ID('tempdb..#formOptionGroup') IS NOT NULL DROP TABLE #formOptionGroup
    SELECT TOP(0) * INTO #formOptionGroup FROM dbo.FormOptionGroup

***FORMOPTIONGROUPS***

    --FormOptionItem
    IF OBJECT_ID('tempdb..#formOptionItem') IS NOT NULL DROP TABLE #formOptionItem
    SELECT TOP(0) * INTO #formOptionItem FROM dbo.FormOptionItem

***FORMOPTIONITEMS***
    `;

        let formOptionGroupInserts = `
    SET IDENTITY_INSERT #formOptionGroup ON
    INSERT INTO #formOptionGroup (Id, Name)
VALUES
***GROUPINSERTS***
    SET IDENTITY_INSERT #formOptionGroup OFF
    `;

        let optionItemInserts = `
    SET IDENTITY_INSERT #formOptionItem ON
***ITEMINSERTS***
    SET IDENTITY_INSERT #formOptionItem OFF
    `;

        let concatString = "";

        let optionGroupValues = options && options?.length > 0
            ? concatString.concat("\r\n", options.map(o => "\r\n(" + o.Id + ", N'" + EscapeSingleQuotes(o.Name) + "')"))
            : "";

        // items could potentially exceed the SQL 1000 insert limit - break into 'insert' chunks
        let items = options != null ? options.map(o => o.Items).flat(1) : [];

        return template
            .replace("***FORMOPTIONGROUPS***", optionGroupValues ? formOptionGroupInserts : "")
            .replace("***GROUPINSERTS***", optionGroupValues)
            .replace("***FORMOPTIONITEMS***", items?.length > 0 ? optionItemInserts : "")
            .replace("***ITEMINSERTS***", items?.length > 0 ? ChunkFormOptionItemInserts(items) : "");
    }


    function ChunkFormOptionItemInserts(items) {
        const batchSize = 1000;
        let index = 0;
        let chunkedInserts = [];
        while (index < items.length) {
            let insertStatement = `INSERT INTO #formOptionItem (Id, Name, Value, OptionGroupId, IsDefault, Sequence)
                    VALUES
                    ***ITEMINSERTVALUES***
                        `;

            let oivConcat = "";
            let optionItemValues = oivConcat.concat("\r\n",
                items
                    .slice(index)
                    .slice(0, batchSize)
                    .map(i =>
                        "\r\n(" + i.Id + ", N'" + EscapeSingleQuotes(i.Name) + "', N'" + EscapeSingleQuotes(i.Value) + "', " + i.OptionGroupId + ", " + i.IsDefault + ", " + i.Sequence + ")"
                    ));

            chunkedInserts.push(insertStatement.replace("***ITEMINSERTVALUES***", optionItemValues));
            index += batchSize;
        }

        return chunkedInserts.join("");
    }


    function RenderMarkdowns(markdowns) {
        let template = `
        --FormMarkdown
        IF OBJECT_ID('tempdb..#formMarkdown') IS NOT NULL DROP TABLE #formMarkdown
        SELECT TOP(0) * INTO #formMarkdown FROM dbo.FormMarkdown
    
    ***FORMMARKDOWNS***
        `;

        let markdownInserts = `
        SET IDENTITY_INSERT #formMarkdown ON
        INSERT INTO #formMarkdown (Id, Markdown)
    VALUES
    ***MARKDOWNINSERTS***
        SET IDENTITY_INSERT #formMarkdown OFF
        `;

        let markdownJoin = "";

        let markdownValues = markdowns
            ? markdownJoin.concat("\r\n", markdowns.map(m => "\r\n(" + m.Id + ", N'" + EscapeSingleQuotes(m.Markdown) + "')"))
            : "";

        let returnValue = template
            .replace("***FORMMARKDOWNS***", markdownValues ? markdownInserts : "")
            .replace("***MARKDOWNINSERTS***", markdownValues);

        if (markdowns?.length === 0) {
            returnValue = template.replace("***FORMMARKDOWNS***", "")
        }
        return returnValue
    }

    /// <summary>
    /// Column A (data.rows[i][0]) is Markdown Identifier - used to link to questions to correct markdown - must be unique within markdown identifiers 
    /// Column B (data.rows[i][1]) is actual markdown
    /// </summary>
    /// <param name="startingMarkdownId"></param>
    /// <param name="data"></param>
    /// <returns></returns>
    function BuildMarkdowns(data) {
        if (data == null)
            return null;

        let markdownId = data.addressStart;
        /*
                    let groupedByTabs = layout?.reduce((layout, {
                        tab,
                        fields,
                        name
                    }) => {
                        (layout[tab] = layout[tab] || []).push({tab, fields, name});
                        return layout;
                    }, {})
         */


        let returnThing = data
            .questions.filter(q => q.markdown);


        let alreadyUsedKey = []

        let actualReturn = []

        for (const curr of returnThing) {
            if (!alreadyUsedKey.includes(curr.dataKey)) {
                let markdowns = new FormMarkdown(markdownId, curr.dataKey, curr.markdown);
                markdownId++;
                actualReturn.push(markdowns)
                alreadyUsedKey.push(curr.dataKey)
            }
        }

        return actualReturn;
    }


    /// <summary>
    /// FormRule
    /// Column A (data.rows[i][0]) is RuleGroup Identifier - string to group rules - unique per group - not used by the app, only used in logic to build script
    /// Column B (data.rows[i][1]) is Field DataName - matches question Field DataName to determine which question it is tied to
    /// Column C (data.rows[i][2]) is Operator - 'Contains', 'EqualTo', 'NotContains', 'NotEqualTo'
    /// Column D (data.rows[i][3]) is ValueMatch - value to check for when rule runs
    /// Column E (data.rows[i][4]) is Conjunction - '', 'And', 'AndAlso', 'Or'
    /// '' signifies simple rule - when evaluated, rule actions are applied
    /// 'And' signifies combination rule - when rule 'and' conjunction, rule actions are applied
    /// 'Or' signifies combination rule - when rule 'or' conjunction, rule actions are applied
    /// 'AndAlso' signifies combination rule - used with and/or logic - when original rule 'and' conjuction, rule actions are applied
    /// FormRuleAction
    /// Column F (data.rows[i][5]) is Rule Action DataName - when rule fires, which question Field DataName is affected
    /// Column G (data.rows[i][6]) is IsRequired 
    /// Column H (data.rows[i][7]) is IsHidden
    /// Column I (data.rows[i][8]) is IsReadonly
    /// </summary>
    function BuildRules(dataModelFile) {
        let allNewRules = GetAllNewRules(dataModelFile.formRuleSetId, dataModelFile);

        allNewRules = SetCurrentChainIndex(dataModelFile.addressStart, allNewRules);

        return allNewRules;
    }

    //Local function since needed nowhere else
    function GetAllNewRules(formRuleSetId, dataModelFile) {
        let formRuleId = parseInt(dataModelFile.addressStart);
        let formRuleActionId = parseInt(dataModelFile.addressStart);
        let formRuleChainId = parseInt(dataModelFile.addressStart);


        let formRuleSequence = 1;

        //Stitch together the rules and the actions
        let allNewRules = dataModelFile.rules.map(r => {
            let actionsForRules =
                dataModelFile.actions.filter(a => a.ruleId == parseInt(r.event.type));

            let allChains = GetListOfChains(r, formRuleChainId, true);
            let anyChains = GetListOfChains(r, formRuleChainId, false);

            let ruleToAdd = new FormRuleFromTool();
            ruleToAdd.FormRuleSetId = formRuleSetId;
            ruleToAdd.Chains =
                allChains?.length > 0 || anyChains?.length > 0 ?
                    allChains != null ? allChains :
                        anyChains != null ?
                            anyChains :
                            [] :
                    [];


            let anyOperatorToUse =
                r.conditions.any?.map(ac => ac);

            anyOperatorToUse = anyOperatorToUse?.length > 0 ? anyOperatorToUse[0] : null;

            let allOperatorToUse =
                r.conditions.all?.map(ac => ac);

            allOperatorToUse = allOperatorToUse?.length > 0 ? allOperatorToUse[0] : null;

            let anyValueToUse =
                r.conditions.any?.map(ac => ac.value);

            anyValueToUse = anyValueToUse?.length > 0 ? anyValueToUse[0] : null;

            let allValueToUse =
                r.conditions.all?.map(ac => ac.value);

            allValueToUse = allValueToUse?.length > 0 ? allValueToUse[0] : null;

            let anyDataName =
                r.conditions.any?.map(ac => ac.fact);

            anyDataName = anyDataName?.length > 0 ? anyDataName[0] : null;

            let allDataName =
                r.conditions.all?.map(ac => ac.fact);

            allDataName = allDataName?.length > 0 ? allDataName[0] : null;

            let subReturn = [];

            let alreadyAddedDataName = [];

            actionsForRules.forEach(afr => {
                let subActions = afr.params.map(p => {
                    let isHidden = false;
                    let isRequired = false;
                    let isReadOnly = false;

                    let shouldShow = afr.func == "show";
                    let shouldHide = afr.func == "hide";

                    if (shouldShow) {
                        isHidden = false;
                    }

                    if (shouldHide) {
                        isHidden = true;
                    }

                    let shouldRequire = afr.func == "require";
                    let shouldUnRequire = afr.func == "unrequire";

                    if (shouldRequire) {
                        isRequired = true;
                    }

                    if (shouldUnRequire) {
                        isRequired = false;
                    }

                    let shouldReadonly = afr.func == "readonly";
                    let shouldReadWrite = afr.func == "readwrite";

                    if (shouldReadonly) {
                        isReadOnly = true;
                    }

                    if (shouldReadWrite) {
                        isReadOnly = false;
                    }

                    let returnSelect = new FormRuleAction
                        (
                            0,
                            afr.ruleId,
                            p,
                            isRequired,
                            isHidden,
                            isReadOnly,
                            0,
                            dataModelFile.rules.find(r => r.ruleId == afr.ruleId)?.formRuleName
                        );
                    return returnSelect;
                });


                let stuffToAdd = subActions.filter(
                    currentAction => !alreadyAddedDataName.includes(currentAction.DataName)).flat(1);
                subReturn = subReturn.concat(stuffToAdd);

            });

            //Retroactively apply the id to the actions
            //Compress the actions down
            let groupedActions = subReturn.reduce((r, { FormRuleId, Id, Sequence, DataName, FormRuleName, ...rest }) => {
                const key = `${FormRuleId}-${Id}-${Sequence}-${DataName}-${FormRuleName}`;
                r[key] = r[key] || { FormRuleId, Id, Sequence, DataName, FormRuleName, "value": [] };
                r[key]["value"].push(rest)
                return r;
            }, {});

            let sequenceIndex = 1;
            let newGroupedActions = [];
            for (const value of Object.values(groupedActions)) {
                let newActionToAdd = new FormRuleAction();
                newActionToAdd.Id = formRuleActionId;
                newActionToAdd.DataName = value.DataName;
                newActionToAdd.FormRuleId = value.FormRuleId;
                newActionToAdd.FormRuleName = value.FormRuleName;
                newActionToAdd.Sequence =
                    value.Sequence > 0 ? value.Sequence : sequenceIndex;
                sequenceIndex++;

                let isHidden = value.value.some(cga => cga.IsHidden);
                let isReadOnly = value.value.some(cga => cga.IsReadonly);
                let isRequired = value.value.some(cga => cga.IsRequired);

                newActionToAdd.IsHidden = isHidden;
                newActionToAdd.IsReadonly = isReadOnly;
                newActionToAdd.IsRequired = isRequired;

                newGroupedActions.push(newActionToAdd);

                formRuleActionId++;
            }

            ruleToAdd.Actions = newGroupedActions;

            ruleToAdd.Id = r.event.type;

            let nonNullOperator = allOperatorToUse ?? anyOperatorToUse;

            let operatorToUse = nonNullOperator.operator != null ? nonNullOperator.operator :
                nonNullOperator.all && nonNullOperator.all.length > 0 ? nonNullOperator.all[0].operator :
                    nonNullOperator.any && nonNullOperator.any.length > 0 ? nonNullOperator.any[0].operator : null;

            ruleToAdd.Operator = OperatorNames[operatorToUse];
            ruleToAdd.ValueMatch = anyValueToUse ? anyValueToUse : allValueToUse;

            ruleToAdd.DataName = anyDataName ? anyDataName : allDataName;

            formRuleId++;

            return ruleToAdd;
        });

        return allNewRules;
    }


    function GetListOfChains(r, formRuleChainId, useAll) {
        //conjunction = "And" / "Or"
        let conjunction = useAll ? "And" : "Or";
        let listOfConditions = useAll ? r.conditions.all : r.conditions.any;


        let allChains = listOfConditions?.map(ca => ca);

        let allChainThing = allChains?.map((ac, index) => {

            let operatorToUse = ac.operator ? ac.operator :
                ac.all ? ac.all?.some(a => a.operator) :
                    ac.any ? ac.any?.some(a => a.operator) : null;

            return new FormRuleChain(formRuleChainId + index, parseInt(r.event.type), conjunction, ac.fact,
                OperatorNames[operatorToUse], ac.value, 0);

        }).splice(1);

        return allChainThing;
    }


    function SetCurrentChainIndex(formRuleChainId, allNewRules) {
        //Set the chain ids after the fact
        let currentChainIndex = formRuleChainId;
        for (const currentRule of allNewRules) {
            for (const currentChain of currentRule.Chains) {
                currentChain.Id = currentChainIndex;
                currentChainIndex++;
            }
        }
        return allNewRules;
    }


    /// <summary>
    /// Column A (data.rows[i][0]) is Form Section Name - if blank uses previous row's section name 
    /// Column B (data.rows[i][1]) is Field Name Label
    /// Column C (data.rows[i][2]) is Field DataName
    /// Column D (data.rows[i][3]) is Required
    /// Column E (data.rows[i][4]) is IsSensitive
    /// Column F (data.rows[i][5]) is MaxLength
    /// Column G (data.rows[i][6]) is MinLength
    /// Column H (data.rows[i][7]) is DataType
    /// Column I (data.rows[i][8]) is Form Option Group
    /// </summary>
    /// <param name="variables"></param>
    /// <param name="options"></param>
    /// <param name="markdowns"></param>
    /// <param name="dataSet"></param>
    /// <returns></returns>
    function BuildSectionsAndQuestions(options, markdowns, dataModelFile) {
        let formSectionId = parseInt(dataModelFile.addressStart);
        let returnList = [];
        let keySeq = 0;
        let klIndex = 0;

        KeyList.forEach((kl) => {
            let prettyTabName = KeyListPretty[klIndex];
            klIndex++;
            let parentSectionToAdd = new FormSection(formSectionId, prettyTabName, null, (keySeq + 1) * 10);
            formSectionId++;
            returnList.push(parentSectionToAdd);

            let childSections =
                dataModelFile.layout.filter(fl => fl.tab == kl)
                    .map((f, index) => {
                        let multipleMatchChecker = []

                        let formSectionSequence = ((keySeq + 1) * 10) + (index + 1);
                        let formSection = new FormSection(formSectionId, f.name, parentSectionToAdd,
                            formSectionSequence);

                        let listOfQuestions = f.fields.map((f, fieldIndex) => {
                            let returnValue = null;

                            let weHaveMatch = false;
                            let questionToAdd = null;

                            while (!weHaveMatch) {
                                let matchQuestions = dataModelFile.questions.filter(q => q.dataKey == f);

                                if (matchQuestions?.length <= 0) {
                                    sqlError = "There is no question with data key " + f + ".";
                                    break;
                                }

                                for (const currMatch of matchQuestions) {
                                    if (!multipleMatchChecker.includes(currMatch.questionId)) {
                                        questionToAdd = currMatch
                                        multipleMatchChecker.push(currMatch.questionId)
                                        weHaveMatch = true;
                                        break;
                                    }
                                }
                            }


                            if (questionToAdd != null) {
                                returnValue = BuildQuestion(questionToAdd.questionId, options, markdowns,
                                    formSection, questionToAdd,
                                    fieldIndex + 1);
                            }

                            return returnValue;
                        });


                        formSection.Questions = listOfQuestions;

                        formSectionId++;

                        return formSection;
                    });

            if (childSections != null) {
                returnList = returnList.concat(childSections);
            }

            keySeq++;

        });

        return returnList;
    }


    /// <summary>
    /// Column B (data.rows[i][1]) is Field Name Label
    /// Column C (data.rows[i][2]) is Field DataName
    /// Column D (data.rows[i][3]) is Required
    /// Column E (data.rows[i][4]) is IsSensitive
    /// Column F (data.rows[i][5]) is MaxLength
    /// Column G (data.rows[i][6]) is MinLength
    /// Column H (data.rows[i][7]) is DataType
    /// Column I (data.rows[i][8]) is Form Option Group
    /// </summary>
    function BuildQuestion(questionId, options, markdowns,
        section, question, sequence) {
        let dataName = question.dataKey;
        let dataType = question.type.toLowerCase();

        if (section.Description == "not an enabled tab for this assistance program") return null;

        let returnValue = new FormQuestionFromTool();

        returnValue.Id = questionId;
        returnValue.Section = section;
        returnValue.LabelText = question.label;
        returnValue.DataName = dataName;
        returnValue.IsRequired = question.required ? parseInt(question.required) == 1 : false;
        returnValue.IsSensitive = question.sensitive;
        returnValue.MaxLength = question.maxLength ? parseInt(question.maxLength) : 0;
        returnValue.MinLength = question.minLength ? parseInt(question.minLength) : 0;
        returnValue.Sequence = sequence;
        returnValue.FieldType = new FormFieldType().FieldType = question.Type;
        returnValue.SelectedType = question.selectedType; //FieldTypes[dataType];
        returnValue.ListName = question.listName;
        returnValue.Type = question.type;

        return returnValue;
    }


    function RenderSections(assistanceFormId, sections) {
        let template = `
    --FormSection
    IF OBJECT_ID('tempdb..#formSection') IS NOT NULL DROP TABLE #formSection
    SELECT TOP(0) * INTO #formSection FROM dbo.FormSection

    SET IDENTITY_INSERT #formSection ON
    INSERT INTO #formSection (Id, AssistanceFormId, Description, ParentFormSectionId, Sequence)
VALUES
***FORMSECTIONS***
    SET IDENTITY_INSERT #formSection OFF
    `;


        let returnValue = "";

        let sectionValues = sections
            ? returnValue.concat("\r\n", sections.map(s => "\r\n(" + s.Id + ", " + assistanceFormId + ", N'" + EscapeSingleQuotes(s.Description) + "', " + (s.ParentFormSection ? s.ParentFormSection?.Id : "NULL") + ", " + s.Sequence + ")"))
            : "";

        return template
            .replace("***FORMSECTIONS***", sectionValues);
    }

    function RenderQuestions(assistanceFormId, sections, markdowns, options) {
        let template = `
    --FormQuestion
    IF OBJECT_ID('tempdb..#formQuestion') IS NOT NULL DROP TABLE #formQuestion
    SELECT TOP(0) * INTO #formQuestion FROM dbo.FormQuestion

    SET IDENTITY_INSERT #formQuestion ON
    INSERT INTO #formQuestion (Id, AssistanceFormId, FormSectionId, IsRequired, IsSensitive, MaxLength, Sequence, LabelText, MarkdownId, MinLength, FormFieldTypeId, DataName, OptionGroupId)
VALUES
***FORMQUESTIONS***
    SET IDENTITY_INSERT #formQuestion OFF
    `;


        let questionListOfLists = sections.map(s => s.Questions);

        let questionsInOrder = [];

        questionListOfLists.forEach(ql => questionsInOrder.push(ql));

        questionsInOrder = questionsInOrder.flat(1)


        let questionConcat = "\r\n";


        let questionValues = questionsInOrder
            ? questionConcat.concat(questionConcat, questionsInOrder
                .filter(q => q)
                .map((q, qIndex) => {
                    let sectionForQuestion =
                        sections?.find(s => s.Questions?.some(qu => qu?.Id == q?.Id));

                    let markdownForQuestion =
                        markdowns?.find(m => m.MarkdownIdentifier == q.DataName);

                    let optionForQuestion =
                        options?.find(o => o.Name == q.ListName);

                    if (q.ListName && !optionForQuestion) {
                        //Grab the list from the common list
                        optionForQuestion = new FormOptionGroup()
                        optionForQuestion.Id = CommonListNames.find(cl => cl.Name == q.ListName)?.Id
                    }

                    let fieldType =
                        FieldTypes.find(ft => ft.FieldType == q.SelectedType);

                    if (!fieldType) {
                        fieldType = FieldTypes.find(ft => ft.FieldType == q.Type)
                    }

                    let isYesNo = IsItYesNoField(q);

                    if (isYesNo) {
                        fieldType = FieldTypes.find(ft => ft.Id == 110)
                    }

                    let sequenceToUse = q.Sequence > 0 ? q.Sequence : qIndex + 1;

                    return `\r\n(${q?.Id}, ${assistanceFormId}, ${sectionForQuestion?.Id}, ${(q?.IsRequired ? 1 : 0)}, ${(q?.IsSensitive ? 1 : 0)}, ${q?.MaxLength}, ${sequenceToUse}, N'${EscapeSingleQuotes(q?.LabelText)}', ${(markdownForQuestion ? markdownForQuestion.Id : "NULL")}, ${q?.MinLength}, ${fieldType?.Id}, '${EscapeSingleQuotes(q?.DataName)}', ${(optionForQuestion ? optionForQuestion.Id ? optionForQuestion.Id : "NULL" : "NULL")})`;
                }
                )
            )
            : "";

        return template
            .replace("***FORMQUESTIONS***", questionValues);
    }


    function RenderFormQuestionToAssistanceService(dataModelFile, sections) {
        let template = `
    --FormQuestionToAssistanceService
    IF OBJECT_ID('tempdb..#formQuestionToAssistanceService') IS NOT NULL DROP TABLE #formQuestionToAssistanceService
    SELECT TOP(0) * INTO #formQuestionToAssistanceService FROM dbo.FormQuestionToAssistanceService

***RECORDINSERTS***
    `;

        let recordInserts = `
        INSERT INTO #formQuestionToAssistanceService (AssistanceServiceId, QuestionId)
    VALUES
    ***INSERTS***
        `;

        let inserts = "";
        let questionListOfLists = sections.map(s => s.Questions);
        let questionsInOrder = [];

        questionListOfLists.forEach(ql => questionsInOrder.push(ql));
        questionsInOrder = questionsInOrder.flat(1)

        let questionValues = questionsInOrder
            .filter(q => q)
            .map((q) => {
                return q.Id
            }
            )

        var filtered = dataModelFile.serviceQuestions.filter(function (item) {
            return questionValues.includes(item.questionId);
        });

        for (const sq of filtered) {
            inserts = inserts.concat("\r\n,", `(${sq.assistanceServiceId}, ${sq.questionId})`);
        }

        inserts = inserts.substring(3)
        inserts = trimEndChar(inserts, ',')
        inserts = trimEndChar(inserts, '\r')
        inserts = trimEndChar(inserts, '\n')

        inserts = inserts.replaceAll("),(", "),\r\n(")


        return template
            .replace("***RECORDINSERTS***", inserts?.length > 0 ? recordInserts : "")
            .replace("***INSERTS***", inserts);
    }

    function trimEndChar(value, char) {
        if (value?.length > 0) {
            if (value[value.length - 1] == char) {
                return value.slice(0, -1)
            }
        }
        return value;
    }

    function RenderFormQuestionToBrandAndService(dataModelFile) {
        let template = `
    --FormQuestionToBrandAndService
    IF OBJECT_ID('tempdb..#formQuestionToBrandAndService') IS NOT NULL DROP TABLE #formQuestionToBrandAndService
    SELECT TOP(0) * INTO #formQuestionToBrandAndService FROM dbo.FormQuestionToBrandAndService

***RECORDINSERTS***
    `;

        let recordInserts = `
    INSERT INTO #formQuestionToBrandAndService (QuestionId, BrandId, AssistanceServiceId)
VALUES
***INSERTS***
    `;

        let inserts = "";

        for (const sbq of dataModelFile.serviceBrandQuestions) {
            inserts = inserts.concat("\r\n,", `(${sbq.questionId}, ${sbq.brandId}, ${sbq.assistanceServiceId})`);
        }
        //Chop off leading comma
        inserts = inserts.substring(3)
        inserts = trimEndChar(inserts, ',')
        inserts = trimEndChar(inserts, '\r')
        inserts = trimEndChar(inserts, '\n')

        inserts = inserts.replaceAll("),(", "),\r\n(")


        return template
            .replace("***RECORDINSERTS***", inserts?.length > 0 ? recordInserts : "")
            .replace("***INSERTS***", inserts);
    }

    function RenderFormRules(formRuleSetId, formRules) {
        let template = `
    --FormRule
    IF OBJECT_ID('tempdb..#formRule') IS NOT NULL DROP TABLE #formRule
    SELECT TOP(0) * INTO #formRule FROM dbo.FormRule

***RULEINSERTS***
    `;

        let ruleInserts = `
    SET IDENTITY_INSERT #formRule ON
    INSERT INTO #formRule(Id, FormRuleSetId, DataName, Operator, ValueMatch, Sequence)
VALUES
***INSERTS***
    SET IDENTITY_INSERT #formRule OFF
    `;


        let formRuleConcat = "\r\n";

        let inserts = formRules && formRules?.length > 0
            ? formRuleConcat.concat(formRules
                .map((r, index) => {

                    let sequenceToUse = r.Sequence > 0 ? r.Sequence : index + 1;
                    return `\r\n(${r.Id}, ${formRuleSetId}, '${EscapeSingleQuotes(r.DataName)}', '${r.Operator}', '${EscapeSingleQuotes(r.ValueMatch)}', ${sequenceToUse})`;
                }))
            : "";

        return template
            .replace("***RULEINSERTS***", inserts ? ruleInserts : "")
            .replace("***INSERTS***", inserts);
    }

    function RenderFormRuleActions(formRules) {
        let template = `
    --FormRuleAction
    IF OBJECT_ID('tempdb..#formRuleAction') IS NOT NULL DROP TABLE #formRuleAction
    SELECT TOP(0) * INTO #formRuleAction FROM dbo.FormRuleAction

***RULEACTIONINSERTS***
    `;

        let ruleActionInserts = `
    SET IDENTITY_INSERT #formRuleAction ON
    INSERT INTO #formRuleAction(Id, FormRuleId, DataName, IsRequired, IsHidden, Sequence, IsReadOnly)
VALUES
***INSERTS***
    SET IDENTITY_INSERT #formRuleAction OFF
    `;

        let formRuleConcat = "\r\n"


        let inserts = formRules && formRules?.length > 0
            ? formRuleConcat.concat(formRules
                .flatMap(a => a.Actions)
                .map(ra => `\r\n(${ra.Id}, ${ra.FormRuleId}, '${EscapeSingleQuotes(ra.DataName)}', ${(ra.IsRequired ? 1 : 0)}, ${(ra.IsHidden ? 1 : 0)}, ${ra.Sequence}, ${(ra.IsReadonly ? 1 : 0)})`).flat(1))
            : "";

        return template
            .replace("***RULEACTIONINSERTS***", inserts ? ruleActionInserts : "")
            .replace("***INSERTS***", inserts);
    }

    function RenderFormRuleChains(formRules) {
        let template = `
    --FormRuleChain
    IF OBJECT_ID('tempdb..#formRuleChain') IS NOT NULL DROP TABLE #formRuleChain
    SELECT TOP(0) * INTO #formRuleChain FROM dbo.FormRuleChain

***RULECHAININSERTS***
    `;

        let ruleChainInserts = `
    SET IDENTITY_INSERT #formRuleChain ON
    INSERT INTO #formRuleChain(Id, FormRuleId, Conjunction, DataName, Operator, ValueMatch, Sequence)
VALUES
***INSERTS***
    SET IDENTITY_INSERT #formRuleChain OFF
    `;


        let formRulesConcat = "\r\n";

        let inserts = formRules
            ? formRulesConcat.concat(formRules
                .flatMap(a => a.Chains)
                ?.map(c => `\r\n(${c.Id}, ${c.FormRuleId}, '${EscapeSingleQuotes(c.Conjunction)}', '${EscapeSingleQuotes(c.DataName)}', '${EscapeSingleQuotes(c.Operator)}', '${EscapeSingleQuotes(c.ValueMatch)}', ${c.Sequence})`))
            : "";

        return template
            .replace("***RULECHAININSERTS***", inserts?.trim().length > 0 ? ruleChainInserts : "")
            .replace("***INSERTS***", inserts);
    }


    function RenderSetup(interfaceId) {
        let template = `
    ---------------------------------------------------------------
        -- Setup Form for Life Science Partner --
    ---------------------------------------------------------------
        -- Configure assistance program to enable digital enrollment
    DECLARE @Services TABLE (AssistanceProgramId int, AssistanceServiceId int)
    INSERT INTO @Services
    SELECT DISTINCT s.AssistanceProgramId, s.Id
    FROM dbo.AssistanceService s
    WHERE s.Id IN (SELECT AssistanceServiceId FROM @AssistanceServices)

    UPDATE AssistanceProgram
    SET InterfaceId=***INTERFACEID***
    WHERE Id IN (
    SELECT AssistanceProgramId FROM @Services
);

    -- Create AssistanceForm record
    SET IDENTITY_INSERT dbo.AssistanceForm ON

    MERGE dbo.AssistanceForm AS Target
    USING (VALUES
    (@AssistanceFormId, @AssistanceFormId, @FormName, @FormDescription, N'AP Destination', NULL, 1)
) AS Source (Id,ApFormId,FormName,FormDescription,DestinationName,DestinationFax, [Status])
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE
    SET Target.ApFormId = Source.ApFormId
    ,Target.FormName = Source.FormName
    ,Target.FormDescription = Source.FormDescription
    ,Target.DestinationName = Source.DestinationName
    ,Target.DestinationFax = Source.DestinationFax
    ,Target.[Status] = Source.[Status]
    WHEN NOT MATCHED THEN
    INSERT (Id,ApFormId,FormName,FormDescription,DestinationName,DestinationFax,[Status])
    VALUES (Source.Id, Source.ApFormId, Source.FormName, Source.FormDescription, Source.DestinationName, Source.DestinationFax, Source.[Status]);

    SET IDENTITY_INSERT dbo.AssistanceForm OFF

    -- Map Form to Assistance Service
    MERGE dbo.AssistanceFormToAssistanceService as Target
    USING  (
        SELECT @AssistanceFormId, AssistanceServiceId
    FROM @Services
) AS Source (AssistanceFormId, AssistanceServiceId)
    ON Target.AssistanceFormId = Source.AssistanceFormId AND Target.AssistanceServiceId = Source.AssistanceServiceId
    WHEN NOT MATCHED THEN
    INSERT (AssistanceFormId,AssistanceServiceId)
    VALUES (Source.AssistanceFormId, Source.AssistanceServiceId);
    `;

        return template
            .replace("***INTERFACEID***", interfaceId);
    }


    function RenderRuleSet(baseName) {
        return `
    ---------------------------------------------------
        -- Create FormRuleSet record --
    ---------------------------------------------------
        SET IDENTITY_INSERT dbo.FormRuleSet ON;

    MERGE dbo.FormRuleSet AS Target
    USING (
        VALUES (@FormRuleSetId, '` + baseName + `Rules')
    ) AS Source (Id, [Name])
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET
    Target.[Name] = Source.[Name]
    WHEN NOT MATCHED THEN
    INSERT (Id, [Name])
    VALUES (Source.Id, Source.[Name])
    ;

    SET IDENTITY_INSERT dbo.FormRuleSet OFF;
    `;
    }


    function RenderTempToPersistent() {
        return `
    ---------------------------------------------------
        -- Merge temporary tables into persistant tables --
    ---------------------------------------------------
        --FormSection
    SET IDENTITY_INSERT dbo.FormSection ON

    MERGE dbo.FormSection AS Target
    USING #formSection AS Source
    ON (Target.Id = Source.Id and Target.AssistanceFormId = Source.AssistanceFormId)
    WHEN MATCHED THEN
    UPDATE SET
    Target.AssistanceFormId = Source.AssistanceFormId
        ,Target.[Description] = Source.[Description]
        ,Target.ParentFormSectionId = Source.ParentFormSectionId
        ,Target.[Sequence] = Source.[Sequence]
        ,Target.Tooltip = Source.Tooltip
    WHEN NOT MATCHED THEN
    INSERT (Id, AssistanceFormId, [Description], ParentFormSectionId, [Sequence], Tooltip)
    VALUES (Source.Id, Source.AssistanceFormId, Source.[Description], Source.ParentFormSectionId, Source.[Sequence], Source.Tooltip);

    SET IDENTITY_INSERT dbo.FormSection OFF

    --FormOptionGroup
    SET IDENTITY_INSERT dbo.FormOptionGroup ON

    MERGE INTO dbo.FormOptionGroup AS Target
    USING #formOptionGroup AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET Target.Name = Source.Name
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, Name)
    VALUES (Source.Id, Source.Name);

    SET IDENTITY_INSERT dbo.FormOptionGroup OFF

    --FormOptionItem
    SET IDENTITY_INSERT dbo.FormOptionItem ON

    MERGE INTO dbo.FormOptionItem AS Target
    USING #formOptionItem AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET
    Target.Name = Source.Name
        ,Target.Value = Source.Value
        ,Target.OptionGroupId = Source.OptionGroupId
        ,Target.IsDefault = Source.IsDefault
        ,Target.Sequence = Source.Sequence
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, Name, Value, OptionGroupId, IsDefault, Sequence)
    VALUES (Source.Id, Source.Name, Source.Value, Source.OptionGroupId, Source.IsDefault, Source.Sequence);

    SET IDENTITY_INSERT dbo.FormOptionItem OFF

    --FormMarkdown
    SET IDENTITY_INSERT dbo.FormMarkdown ON

    MERGE INTO dbo.FormMarkdown AS Target
    USING #formMarkdown AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET Target.Markdown = Source.Markdown
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, Markdown)
    VALUES (Source.Id, Source.Markdown);

    SET IDENTITY_INSERT dbo.FormMarkdown OFF

    --FormQuestion
    SET IDENTITY_INSERT dbo.FormQuestion ON

    MERGE INTO dbo.FormQuestion AS Target
    USING #formQuestion AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET
    Target.AssistanceFormId = Source.AssistanceFormId
        ,Target.FormSectionId = Source.FormSectionId
        ,Target.IsRequired = Source.IsRequired
        ,Target.IsSensitive = Source.IsSensitive
        ,Target.MaxLength = Source.MaxLength
        ,Target.Sequence = Source.Sequence
        ,Target.LabelText = Source.LabelText
        ,Target.PlaceHolderText = Source.PlaceHolderText
        ,Target.Tooltip = Source.Tooltip
        ,Target.RegEx = Source.RegEx
        ,Target.MarkdownId = Source.MarkdownId
        ,Target.MinLength = Source.MinLength
        ,Target.FormFieldTypeId = Source.FormFieldTypeId
        ,Target.DataName = Source.DataName
        ,Target.OptionGroupId = Source.OptionGroupId
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, AssistanceFormId, FormSectionId, IsRequired, IsSensitive, MaxLength, Sequence, LabelText, PlaceHolderText, Tooltip, RegEx, MarkdownId, MinLength, FormFieldTypeId, DataName, OptionGroupId)
    VALUES (Source.Id, Source.AssistanceFormId, Source.FormSectionId, Source.IsRequired, Source.IsSensitive, Source.MaxLength, Source.Sequence, Source.LabelText, Source.PlaceHolderText, Source.Tooltip, Source.RegEx, Source.MarkdownId, Source.MinLength, Source.FormFieldTypeId, Source.DataName, Source.OptionGroupId);

    SET IDENTITY_INSERT dbo.FormQuestion OFF

    --FormQuestionToAssistanceService
    MERGE INTO dbo.FormQuestionToAssistanceService AS Target
    USING #formQuestionToAssistanceService AS Source
    ON (Target.QuestionId = Source.QuestionId AND Target.AssistanceServiceId = Source.AssistanceServiceId)
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (QuestionId, AssistanceServiceId)
    VALUES (Source.QuestionId, Source.AssistanceServiceId);


    --FormQuestionToBrandAndService
    MERGE INTO dbo.FormQuestionToBrandAndService AS Target
    USING #formQuestionToBrandAndService AS Source
    ON (Target.QuestionId = Source.QuestionId AND Target.BrandId = Source.BrandId AND Target.AssistanceServiceId = Source.AssistanceServiceId)
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (QuestionId, BrandId, AssistanceServiceId)
    VALUES (Source.QuestionId, Source.BrandId, Source.AssistanceServiceId);

    --FormRule
    SET IDENTITY_INSERT dbo.FormRule ON

    MERGE INTO dbo.FormRule AS Target
    USING #formRule AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET
    Target.FormRuleSetId = Source.FormRuleSetId
        ,Target.DataName = Source.DataName
        ,Target.Operator = Source.Operator
        ,Target.ValueMatch = Source.ValueMatch
        ,Target.Sequence = Source.Sequence
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, FormRuleSetId, DataName, Operator, ValueMatch, Sequence)
    VALUES (Source.Id, Source.FormRuleSetId, Source.DataName, Source.Operator, Source.ValueMatch, Source.Sequence);

    SET IDENTITY_INSERT dbo.FormRule OFF

    --FormRuleAction
    SET IDENTITY_INSERT dbo.FormRuleAction ON

    MERGE INTO dbo.FormRuleAction AS Target
    USING #formRuleAction AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET
    Target.FormRuleId = Source.FormRuleId
        ,Target.DataName = Source.DataName
        ,Target.IsRequired = Source.IsRequired
        ,Target.IsHidden = Source.IsHidden
        ,Target.Sequence = Source.Sequence
        ,Target.IsReadonly = Source.IsReadonly
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, FormRuleId, DataName, IsRequired, IsHidden, Sequence, IsReadonly)
    VALUES (Source.Id, Source.FormRuleId, Source.DataName, Source.IsRequired, Source.IsHidden, Source.Sequence, Source.IsReadonly);

    SET IDENTITY_INSERT dbo.FormRuleAction OFF

    --FormRuleChain
    SET IDENTITY_INSERT dbo.FormRuleChain ON

    MERGE INTO dbo.FormRuleChain AS Target
    USING #formRuleChain AS Source
    ON (Target.Id = Source.Id)
    WHEN MATCHED THEN
    UPDATE SET
    Target.FormRuleId = Source.FormRuleId
        ,Target.Conjunction = Source.Conjunction
        ,Target.DataName = Source.DataName
        ,Target.Operator = Source.Operator
        ,Target.ValueMatch = Source.ValueMatch
        ,Target.Sequence = Source.Sequence
    WHEN NOT MATCHED BY TARGET THEN
    INSERT (Id, FormRuleId, Conjunction, DataName, Operator, ValueMatch, Sequence)
    VALUES (Source.Id, Source.FormRuleId, Source.Conjunction, Source.DataName, Source.Operator, Source.ValueMatch, Source.Sequence);

    SET IDENTITY_INSERT dbo.FormRuleChain OFF
    `;
    }

    function RenderRuleSetToAssistanceProgram() {
        return `
    ------------------------------------------------------------
        -- Map Form Rules for this form to the Assistance Program --
    ------------------------------------------------------------
        MERGE dbo.FormRuleToAssistanceProgram AS Target
    USING (
        SELECT DISTINCT s.AssistanceProgramId, @FormRuleSetId
    FROM @Services s
    LEFT OUTER JOIN FormRuleToAssistanceProgram AS rp ON rp.AssistanceProgramId = s.AssistanceProgramId
    WHERE rp.AssistanceProgramId IS NULL
) AS Source (AssistanceProgramId, FormRuleSetId)
    ON (Target.AssistanceProgramId = Source.AssistanceProgramId AND Target.FormRuleSetId = Source.FormRuleSetId)
    WHEN NOT MATCHED THEN
    INSERT (AssistanceProgramId, FormRuleSetId)
    VALUES (Source.AssistanceProgramId, Source.FormRuleSetId);
    `;
    }

    function RenderCleanUp() {
        return `
    -----------------------------------------------------------------------------
        -- Remove everything that wasn't merged/inserted from the temporary tables --
    -----------------------------------------------------------------------------
        --FormQuestionToAssistanceService
    DELETE a FROM FormQuestionToAssistanceService a
    LEFT JOIN #formQuestionToAssistanceService b ON a.QuestionId = b.QuestionId AND a.AssistanceServiceId = b.AssistanceServiceId
    WHERE a.AssistanceServiceId IN (SELECT AssistanceServiceId FROM @AssistanceServices)
    AND (
        ((a.QuestionId BETWEEN @AddressStart AND @AddressEnd) AND (b.AssistanceServiceId IS NULL OR b.QuestionId IS NULL))
    OR
    (a.QuestionId NOT BETWEEN @AddressStart AND @AddressEnd)
)
    DELETE a FROM FormQuestionToAssistanceService a
    WHERE a.AssistanceServiceId NOT IN (SELECT AssistanceServiceId FROM @AssistanceServices)
    AND a.QuestionId BETWEEN @AddressStart AND @AddressEnd

    --FormQuestionToBrandAndService
    DELETE a FROM FormQuestionToBrandAndService a
    LEFT JOIN #formQuestionToBrandAndService b ON a.QuestionId = b.QuestionId AND a.AssistanceServiceId = b.AssistanceServiceId AND a.BrandId = b.BrandId
    WHERE a.AssistanceServiceId IN (SELECT AssistanceServiceId FROM @AssistanceServices)
    AND (
        ((a.QuestionId BETWEEN @AddressStart AND @AddressEnd) AND (b.AssistanceServiceId IS NULL OR b.QuestionId IS NULL))
    OR
    (a.QuestionId NOT BETWEEN @AddressStart AND @AddressEnd)
)
    DELETE a FROM FormQuestionToBrandAndService a
    WHERE a.AssistanceServiceId NOT IN (SELECT AssistanceServiceId FROM @AssistanceServices)
    AND a.QuestionId BETWEEN @AddressStart AND @AddressEnd

    --FormQuestion
    DELETE FROM practice.FormAnswer --delete bad FormAnswers first
    WHERE QuestionId IN (
    SELECT Id
    FROM dbo.FormQuestion
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formQuestion)
)
    DELETE FROM dbo.FormQuestion
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formQuestion)

    --FormOptionItem
    DELETE FROM dbo.FormOptionItem
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formOptionItem)

    --FormOptionGroup
    DELETE FROM dbo.FormOptionGroup
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formOptionGroup)

    --FormSection
    DELETE FROM dbo.FormSection
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formSection)

    --FormMarkdown
    DELETE FROM dbo.FormMarkdown
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formMarkdown)

    --FormRuleChain
    DELETE FROM dbo.FormRuleChain
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formRuleChain)

    --FormRuleAction
    DELETE FROM dbo.FormRuleAction
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formRuleAction)

    --FormRule
    DELETE FROM dbo.FormRule
    WHERE Id BETWEEN @AddressStart AND @AddressEnd
    AND Id NOT IN (SELECT Id FROM #formRule)
    `;
    }


    function EscapeSingleQuotes(value) {
        return value?.replaceAll("'", "''") ?? "";
    }

    return { SaveJsonAsSqlFile, SaveFileContents }
}

export default DataModelToolHelpers;